// ** MUI Imports
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import Table from "@mui/material/Table";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import { Avatar, CardHeader, Pagination } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getAllUsers } from "../../../Redux/Auth/Action";
import { useDispatch, useSelector } from "react-redux";

const Customers = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { auth } = useSelector((store) => store);
  const [users, setUsers] = useState([]);

  useEffect(() => {
    dispatch(getAllUsers());
  }, []);

  useEffect(() => {
    setUsers(auth.users);
  }, [auth]);


  function handlePaginationChange(event, value) {
  }
  return (
    <Box>
      <Card>
        <CardHeader
          title="All Customers"
          sx={{
            pt: 2,
            alignItems: "center",
            "& .MuiCardHeader-action": { mt: 0.6 },
          }}
        />
        {users.length ? (
          <TableContainer>
            <Table sx={{ minWidth: 390 }} aria-label="table in dashboard">
              <TableHead>
                <TableRow>
                  <TableCell>#</TableCell>
                  <TableCell>First Name</TableCell>
                  <TableCell>Last Name</TableCell>
                  <TableCell>Email</TableCell>
                  <TableCell>Phone</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {users.slice(0, 10).map((item, index) => (
                  <TableRow
                    hover
                    key={item.name}
                    sx={{
                      "&:last-of-type td, &:last-of-type th": { border: 0 },
                    }}
                  >
                    <TableCell>{index + 1}</TableCell>
                    <TableCell>{item.firstName}</TableCell>
                    <TableCell>{item.lastName}</TableCell>
                    <TableCell>{item.email}</TableCell>
                    <TableCell>{item.phone}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        ) : (
          "No Customers found!"
        )}
      </Card>
      {users.length && (
        <Card className="mt-2 felx justify-center items-center">
          <Pagination
            className="py-5 w-auto"
            size="large"
            count={10}
            color="primary"
            onChange={handlePaginationChange}
          />
        </Card>
      )}
    </Box>
  );
};

export default Customers;
